import { reactive, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  queryCheckList,
  deleteCheckById,
  finishCheckStatus,
} from "@/api/check";
import { postDownload } from "@/utils";

export default function useCheckTable() {
  // 表单搜索ref
  const searchRef = ref(null);

  //  调整组件ref
  const editRef = ref(null);

  // 搜索表单
  const searchData = reactive({
    number: null,
    checkUser: null,
    warehouseId: null,
    checkStartTime: null,
    checkFinishTime: null,
    remark: null,
    status: null,
    createName: null,
    startTime: null,
    endTime: null,
    descs: "create_time",
  });

  // 表格遮罩
  const tableLoading = ref(false);

  // 表格数据
  const tableData = ref([]);

  // 表格列配置
  const columns = ref([
    {
      label: "盘点单号",
      prop: "number",
    },
    {
      label: "仓库名称",
      prop: "warehouseName",
    },
    {
      label: "创建人",
      prop: "createByText",
    },

    {
      label: "创建时间",
      prop: "createTime",
    },
    // {
    //   label: "盘点日期",
    //   prop: "checkDate",
    // },
    // {
    //   label: "盘点人",
    //   prop: "checkUser",
    // },
    // {
    //   label: "备注",
    //   prop: "remark",
    //   width: 150,
    // },

    // {
    //   label: "盘点开始时间",
    //   prop: "startTime",
    // },
    // {
    //   label: "盘点结束时间",
    //   prop: "finishTime",
    // },
    // {
    //   label: "状态",
    //   prop: "status",
    // },
  ]);

  // 分页配置
  const pages = reactive({
    page: 1,
    size: 10,
    total: 0,
  });
  const handleSizeChange = (val) => {
    pages.size = val;
    pages.page = 1;
    getList();
  };
  const handleCurrentChange = (val) => {
    pages.page = val;
    getList();
  };
  // 范围时间选择器
  const dateRangeSelector = reactive({
    checkDate: null,
    createDate: null,
  });

  // 搜索栏折叠
  const visible = ref(false);

  // 多选选中的id
  const multipleSelectionIds = ref([]);

  // 多选函数
  const handleSelectionChange = (val) => {
    multipleSelectionIds.value = [];
    val.forEach((item) => {
      multipleSelectionIds.value.push(item.id);
    });
  };

  // 点击新增或编辑或详情
  const handleAdjust = (row, type) => {
    editRef.value?.handleDialogOpen({ row, type });
  };

  // 获取数据
  const getList = () => {
    tableLoading.value = true;
    queryCheckList({
      ...searchData,
      page: pages.page,
      limit: pages.size,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  //重置按钮
  const handleReset = () => {
    searchRef.value?.resetFields();
    dateRangeSelector.checkDate = null;
    dateRangeSelector.createDate = null;
    searchData.startTime = null;
    searchData.endTime = null;
    searchData.checkStartTime = null;
    searchData.checkFinishTime = null;
    pages.page = 1;
    getList();
  };

  // 点击删除或批量删除
  const handleClickDel = (id, type) => {
    if (type) {
      if (multipleSelectionIds.value.length == 0)
        return ElMessage.warning("未选择任何数据");
      handleDelete(multipleSelectionIds.value.join(","));
    } else {
      handleDelete([id].join(","));
    }
  };

  // 删除
  const handleDelete = (ids) => {
    ElMessageBox.confirm("确定删除所选数据吗?", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteCheckById({ ids }).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  // 导出
  const handleExport = () => {
    ElMessageBox.confirm("确定导出盘点数据吗?", "导出", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        postDownload("/check/export", {}, "盘点管理数据.xlsx");
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  // 筛选框盘点时间变化
  const checkDateChange = () => {
    searchData.checkStartTime = dateRangeSelector.checkDate?.[0];
    searchData.checkFinishTime = dateRangeSelector.checkDate?.[1];
  };

  // 创建时间变化
  const createDateChange = () => {
    searchData.startTime = dateRangeSelector.createDate?.[0];
    searchData.endTime = dateRangeSelector.createDate?.[1];
  };

  // 点击完成盘点
  const handleCheckDone = (row) => {
    ElMessageBox.confirm("确定修改盘点状态吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        finishCheckStatus(row.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {});
  };

  return {
    searchRef,
    editRef,
    searchData,
    tableLoading,
    tableData,
    columns,
    pages,
    visible,
    dateRangeSelector,
    handleAdjust,
    getList,
    handleSizeChange,
    handleCurrentChange,
    handleReset,
    handleClickDel,
    handleExport,
    handleSelectionChange,
    checkDateChange,
    createDateChange,
    handleCheckDone,
  };
}
